<template>
    <div class="manage--left" ref="lesson-left">
        <!-- Search -->
        <div class="manage--search--left">
            <input type="text" autocomplete="off" v-model="keyword" v-on:keyup="filtterByKeyword" :placeholder="data.type == $CONST.MANAGE.TYPE.LESSON ? $t('manage_lesson.keyWord') : $t('new.title69')" class="input--search--left" />
            <button type="button" v-on:click="filtterByKeyword" class="button--search--left">
                <img :src="$CONST.HEADER.IMG.SEARCH" />
            </button>
        </div>
        <!-- List -->
        <div class="div-list-lessons">
            <template v-for="(item, index) in result">
                <div class="nqt--list--lessons" :class="[{active: item[filterFieldID] == data[activeID]}, {isTeacher: !item.isTeacher && data.type == $CONST.MANAGE.TYPE.LESSON}, {notStudy: item.status == 0}]" v-on:click="changeItem({id: item[filterFieldID], type: data.type, isAllowed: item.isTeacher, keyword: keyword, change: true, status: item.status})" :key="index">
                    <template v-if="item.status==0">
                        <p class="title-lesson" style="color:#9b99a2">
                            <template v-if="item[filterField].search('@') !== -1">{{item[filterField].substring(0, item[filterField].search('@'))}}</template>
                            <template v-if="item[filterField].search('@') == -1">{{item[filterField]}}</template>
                        </p>
                    </template>
                    <template v-else>
                        <p class="title-lesson">
                            <template v-if="item[filterField].search('@') !== -1">{{item[filterField].substring(0, item[filterField].search('@'))}}</template>
                            <template v-if="item[filterField].search('@') == -1">{{item[filterField]}}</template>
                        </p>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                keyword: this.data.keyword || null,
                result: [],
                filterField: null,
                filterFieldID: null,
                activeID: null,
                timeNow: new Date(),
            };
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        created() {
            // console.log(this.data);
            this.init();
        },
        methods: {
            init: function () {
                this.result = this.data.list;
                this.filterField = this.data.type == this.$CONST.MANAGE.TYPE.LESSON ? "courseName" : "userName";
                this.filterFieldID = this.data.type == this.$CONST.MANAGE.TYPE.LESSON ? "courseId" : "id";
                this.activeID = this.data.type == this.$CONST.MANAGE.TYPE.LESSON ? "courseId" : "studentId";
                this.keyword = this.data.type == this.$CONST.MANAGE.TYPE.LESSON ? null : this.keyword;
                this.filtterByKeyword();
            },
            compareDate: function (date) {
                if (date == null) return true;
                var dateA = this.timeNow.getTime();
                var dateB = new Date(date).getTime();
                if (dateA > dateB) {
                    return false;
                }
                return true;
            },
            filtterByKeyword: function () {
                var keyword = this.keyword;
                if (keyword == null || keyword == "") {
                    this.result = this.data.list;
                    return;
                }
                keyword = keyword.toUpperCase();
                this.result = this.data.list.filter((item) => item[this.filterField].toUpperCase().indexOf(keyword) > -1);
            },
            changeItem: function (params) {
                window.sessionStorage.setItem("checkPageCurrent", false);
                if(params.status==0){
                    this.$confirm(window.vm.$i18n.t("new.title94"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
                    .then(() => {})
                    .catch(() => {});
                } else { 
                    if (!params.isAllowed && params.type == this.$CONST.MANAGE.TYPE.LESSON) {
                        this.$confirm(window.vm.$i18n.t("new.title90"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
                            .then(() => {})
                            .catch(() => {});
                        return;
                    }
                    this.$emit("changeItem", params);
                    document.getElementsByTagName("body")[0].classList.remove("show-menu-1");
                }
            },
        },
    };
</script>
<style scoped>
    .nqt--list--lessons {
        cursor: pointer !important;
    }
    .div-list-lessons {
        cursor: pointer !important;
        overflow: auto;
        height: 675px;
    }
    .nqt-end {
        background: #1f1313;
        height: calc(100% - 10px);
        position: absolute;
        right: 5px;
        width: auto;
        top: 5px;
        color: #fff;
        padding: 7px;
        font-size: 10px;
        border-radius: 7px;
        display: flex;
    }
    .nqt--list--lessons:hover {
        background: #d7d7d7;
    }
    .isTeacher {
        color: #9b99a2;
        display: none;
    }
    .notStudy {
        display: none;
    }
    .button--search--left{
        width: auto!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/left.vue